import Proptypes from 'prop-types';
import React from 'react';

const Transfer = ({ height = '30', width = '27' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 27"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      className="college-branded-icon-stroke"
      d="M29.0001 9.27007L25.1813 14.9982L20.7261 9.90653"
      stroke="#006894"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M25.1425 14.9218C26.0972 7.00434 20.2036 1.25078 13.5335 1.00893C6.86349 0.75435 1.24995 5.97328 1.0081 12.6433C0.766243 19.3134 5.97245 24.9269 12.6425 25.1688C17.6578 25.3597 22.0748 22.4575 24.0605 18.1678"
      stroke="#006894"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Transfer.propTypes = {
  height: Proptypes.string,
  width: Proptypes.string,
};

export default Transfer;
